// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"1f9e69ee","482":"69db7009","574":"69db7009","939":"5e168186","973":"69db7009"}[chunkId] + ".chunk.css";
};